import { AppProvider, useAppContext } from "./AppContext";
import Grid from "./components/Grid";
import Modal from "./components/Modal";
import Sidebar from "./components/Sidebar";

import "./scss/index.scss";

function DebugPanel() {
    const { isDebugEnabled, lastEndpoint, maxPages, page } = useAppContext();

    if (!isDebugEnabled) return null;

    return (
        <div className="p-3 d-none d-md-block col-12">
            <div className="bg-light-subtle px-3 py-2 border rounded-1">
                <h5>DEBUG MODE</h5>
                <p>Last Endpoint: {lastEndpoint}</p>
                <p>Total Pages: {maxPages}</p>
                <p>Current Page: {page}</p>
            </div>
        </div>
    );
}

function Layout() {
    const {
        toggleMobileFilter,
        mobileFilterOpen,
        loadMoreRef,
        isBusy,
        onLoadMore,
        page,
        maxPages,
    } = useAppContext();

    return (
        <>
            <div className="container-fluid px-lg-4">
                <div className="row">
                    <Grid />

                    <div className="col-xl-3 my-4 px-4 px-lg-3 d-xl-block d-none">
                        <Sidebar />
                    </div>

                    {page < maxPages && (
                        <div className="rl-load-more-wrapper d-flex col-xl-9 col-12 mb-5 flex-column align-items-center">
                            <button
                                ref={loadMoreRef}
                                disabled={isBusy}
                                type="button"
                                className="rl-load-more-when-in-vp btn text-secondary text-small fw-bold rounded-pill px-4 py-2 shadow-lg border"
                                onClick={onLoadMore}
                            >
                                {isBusy ? "Loading..." : "Load More"}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div
                className="d-flex d-xl-none d-flex align-items-center justify-content-center position-fixed w-100"
                style={{ bottom: "3em", zIndex: "102" }}
            >
                <button
                    type="button"
                    className="btn btn-primary rounded-pill px-4 text-uppercase"
                    onClick={toggleMobileFilter}
                >
                    Filter
                </button>
            </div>
            <Modal
                onClose={(e) => {
                    e.preventDefault();
                    toggleMobileFilter();
                }}
                isModalOpen={mobileFilterOpen}
                className="border-1 border-light-subtle p-0 rounded relative"
                style={{
                    maxHeight: "65dvh",
                    overscrollBehavior: "contain",
                }}
            >
                <Sidebar className="h-100 py-3 px-4 w-100" />
            </Modal>
        </>
    );
}

export default function App() {
    return (
        <AppProvider>
            <DebugPanel />
            <Layout />
        </AppProvider>
    );
}
